import React, { useState, useEffect, useMemo } from "react";
import Moment from "moment";
import toast, { Toaster as ToasterPrimary } from 'react-hot-toast';
import { ReactComponent as IconClose } from "../build/images/closecircle22px.svg";
import { ReactComponent as DangerIcon } from "../build/images/danger_pause.svg";
import { useDispatch, useSelector } from "react-redux";
import { InterationNotifier } from "../actions";

let isStart = false;
let timer = 0;

const Automatic_pause = ({ insert_pause_automatic, pauses }) => {

  const [time, setTime] = useState(0);
  const dispatch = useDispatch();
  const IPCurrent = useSelector(state => state.ipcurrent)
  let valueDiff = 0

  const startTimer = () => {

    setTime({
      time: time,
      start: Date.now() - time,
      isOn: true
    });

    timer = setInterval(
      () => {
        setTime({time: Date.now() - 0})
        // clearInterval(timer)
      },1000);
  }

  const handleChange = (idPause) => {
    insert_pause_automatic(idPause)
  }

  const closeToast = () => {
    toast.remove();
  }

  // useMemo(() => {
  //   clearInterval(timer)
  // },[]);

  const HandleViewToast = (tm_warning_before) => {
    let text = ''
    let value = ''

    if(tm_warning_before === 60){
      text = 'minuto'
      value = '1'
    }

    if(tm_warning_before < 60){
      text = 'segundos'
      value = tm_warning_before;
    }

    if(tm_warning_before > 60 && tm_warning_before < 3600){
      text = 'minutos'
      value = Math.round(tm_warning_before/60) 
    }

    if(tm_warning_before === 3600 ){
      text = 'hora'
      value = '1'
    }

    if(tm_warning_before > 3600 ){
      text = ''
      let aux = Moment().format('00:00:00', 'HH:mm:ss')      
      value = Moment(aux, 'HH:mm:ss').add(tm_warning_before,'seconds').format('HH:mm:ss')
    }

    toast.custom(
      <div className="container__pause-automatic">
          <div className="container__pause-automatic__icon">
            <DangerIcon />
          </div>
          <div className="container__pause-automatic__separator">
            <div className="container__pause-automatic__box">
              <strong>
                  Em {value} {text} a sua pausa automática será ativada.
              </strong>
              <div className="container__pause-automatic__box-icon" onClick={() => closeToast()}>
                  <IconClose />
              </div>
            </div>
            <span>
              Caso você esteja em atendimento, a pausa futura aparecerá e após o encerramento do atendimento, a sua pausa automática será ativada.
            </span>
          </div>
       </div>,{
        id: 2,
        position: "bottom-left"
       }
    )
  }

  useEffect(() => {
    if(IPCurrent.length !== 0 && !isStart){
      startTimer();
      isStart = true;
    }
  }, [IPCurrent]);
  
  useEffect(() => {

    valueDiff = parseInt(Math.abs(Math.round(IPCurrent.difftime)))

    let now = Moment().format('HH:mm');
    if(IPCurrent.difftime < 0)
      now = Moment().subtract(valueDiff,'seconds').format('HH:mm');
    else
      now = Moment().add(valueDiff,'seconds').format('HH:mm');

    if(now === pauses[0].hora){
        dispatch(InterationNotifier("Você entrou na pausa automática","automaticpause"));
        handleChange(pauses[0].pauseid);

    }


    // antes de olhar o horário da máquina
    // if(Moment().format('HH:mm:ss') === pauses[0].hora)
    //     handleChange(pauses[0].pauseid);
    if(Moment().format('HH:mm:ss') === pauses[0].hora_warning){
      setTimeout(() => {
        HandleViewToast(pauses[0].tm_warning_before)
      },[1000])
    }

  }, [time]);

  return  ""
};

export default Automatic_pause;
